<fe-header style="z-index: 10000"></fe-header>
<main class="mb-26 mb-md-20">
    <section>
        <fe-card-landing-title
            *ngIf="this.selectedImage === null"
            [title]="destinationTitle"
            [imageSrc]="this.defaultImage | cdn"
        ></fe-card-landing-title>
        <img
            *ngIf="this.selectedImage !== null"
            class="container-fluid px-0 d-none d-sm-flex image_sucursal"
            [src]="this.selectedImage"
            alt="Alamo City Horizontal"
        />
        <img
            *ngIf="this.selectedImage !== null"
            class="container-fluid px-0 d-flex d-sm-none"
            [src]="this.selectedImage"
            alt="Alamo City Vertical"
        />
    </section>

    <section
        class="destination__airport__title py-2 d-flex align-items-center justify-content-center"
        *ngIf="this.selectedImage !== null"
    >
        <h1 class="destination__airport__title__text my-0">
            {{ this.destinationTitle }}
        </h1>
    </section>
    <section
        class="destination__airport__search py-4 px-0 px-md-4 px-lg-8 d-flex"
    >
        <fe-search-reservation
            class="mb-3 w-100"
            [isNormal]="true"
        ></fe-search-reservation>
    </section>
    <fe-location-detail-destination
        (locationDetailsLoaded)="onLocationDetailsLoaded($event)"
    ></fe-location-detail-destination>

    <section
        class="destination__airport__description py-2 d-flex align-items-center justify-content-center"
        *ngIf="destinationDescription !== null"
    >
        <div class="container py-4 px-0 px-md-2">
            <h4 [innerHTML]="destinationTitle"></h4>
            <p
                *ngIf="destinationDescription"
                class="city__airport__bottom__text m-0"
                [innerHTML]="destinationDescription"
            ></p>
            <p
                *ngIf="destinationDescriptionExtra"
                class="city__airport__bottom__text m-0"
                [innerHTML]="destinationDescriptionExtra"
            ></p>
        </div>
    </section>
    <fe-car-rental-policy></fe-car-rental-policy>
</main>
<fe-footer></fe-footer>
